import type { AbilityDef } from "../../sim";

/**
 * Издёвки (Джон 04.11.2026, 22:29: Wide Arm Spell Casting — «Эй, ну чё ты, давай дерись», Breakdance 1990, пара танцев):
 * своя кнопка — тачпад DualSense, T на клавиатуре; и сами — после 2 с без ввода. Дают немного Ярости, но открывают:
 * в издёвке не закрыться. Любой ввод прерывает сразу. Длина — клип целиком, кадр клипа на два кадра мира.
 */
const taunt = (id: string, name: string, pose: string, frames: number): AbilityDef => ({
  id,
  name,
  input: { taunt: true },
  pose,
  startup: frames,
  active: 0,
  recovery: 0,
  tauntMeter: 2,
});

export const TAUNTS: readonly AbilityDef[] = [
  taunt("taunt-come-on", "Издёвка «давай дерись»", "tauntComeOn", 200),
  taunt("taunt-breakdance", "Издёвка — брейк", "tauntBreak", 140),
  taunt("taunt-chicken", "Издёвка — танец", "tauntChicken", 270),
];
